"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __aws_sdk_bucket_endpoint_middleware = require("@aws-sdk/bucket-endpoint-middleware");
var __aws_sdk_middleware_stack = require("@aws-sdk/middleware-stack");
var __aws_sdk_ssec_middleware = require("@aws-sdk/ssec-middleware");
var SelectObjectContent_1 = require("../model/SelectObjectContent");
var SelectObjectContentCommand = /** @class */ (function () {
    function SelectObjectContentCommand(input) {
        this.input = input;
        this.model = SelectObjectContent_1.SelectObjectContent;
        this.middlewareStack = new __aws_sdk_middleware_stack.MiddlewareStack();
    }
    SelectObjectContentCommand.prototype.resolveMiddleware = function (clientStack, configuration) {
        var handler = configuration.handler;
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {},
            model: this.model
        };
        stack.add(__aws_sdk_bucket_endpoint_middleware.bucketEndpointMiddleware({
            forcePathStyle: configuration.forcePathStyle,
            preformedBucketEndpoint: configuration.bucketEndpoint,
            useAccelerateEndpoint: configuration.useAccelerateEndpoint,
            useDualstackEndpoint: configuration.useDualstackEndpoint
        }), {
            step: "build",
            priority: 0
        });
        stack.add(__aws_sdk_ssec_middleware.ssecMiddleware({
            base64Encoder: configuration.base64Encoder,
            hashConstructor: configuration.md5,
            ssecProperties: {
                $serverSideEncryptionKey: {
                    targetProperty: "SSECustomerKey",
                    hashTargetProperty: "SSECustomerKeyMD5"
                }
            },
            utf8Decoder: configuration.utf8Decoder
        }), {
            step: "initialize",
            priority: 0
        });
        return stack.resolve(handler(handlerExecutionContext), handlerExecutionContext);
    };
    return SelectObjectContentCommand;
}());
exports.SelectObjectContentCommand = SelectObjectContentCommand;
//# sourceMappingURL=SelectObjectContentCommand.js.map